/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * dataprocessGroup
 */
export interface DataprocessGroup { 
    id?: number;
    /**
     * the name of the dataprocessGroup
     */
    name?: string;
    /**
     * the description of the dataprocessGroup
     */
    description?: string;
    /**
     * jsonString for the icon of the dataprocessGroup
     */
    icon?: string;
    /**
     * the dataprocessGroups are sorted according to this value
     */
    sort?: number;
}

